import { useState, useEffect } from 'react';

/**
 * 動態偵測 #main-nav 的實際高度（含 Beta 公告條）
 * 用 ResizeObserver 監聽，導覽列高度變化時自動更新
 * @param extraPadding 額外留白（px），預設 16
 */
export function useNavHeight(extraPadding = 16): number {
  const [height, setHeight] = useState(96); // fallback 預設值

  useEffect(() => {
    const nav = document.getElementById('main-nav');
    if (!nav) return;

    const update = () => setHeight(nav.offsetHeight + extraPadding);
    update();

    const observer = new ResizeObserver(update);
    observer.observe(nav);

    return () => observer.disconnect();
  }, [extraPadding]);

  return height;
}
